import React, { useEffect, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction, masterActions } from "../../../_store";
import { useLocation } from "react-router-dom";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../../utils/formatTime";
import generateMessagePDF from "../../../components/common/export/Reports/generateMessagePDF";
import generatePhotoPDF from "../../../components/common/export/Reports/generatePhotoPDF";
import CustomLoader from "../../../components/common/ui/Loader";
import loaddataimg from "../../../assets/svg/load-data.svg";
import { handleDateRangeBlur } from "../../../hooks/useDateRangeBlur";
import { handleDateInput } from "../../../hooks/useDateInputHandler";

const Photos = ({ loadData, render }) => {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { direction } = useSelector((x) => x.dropdownOptions);
  const { photoList, loading, inmate, inmateInfoTabData, photoTotalCount } =
    useSelector((x) => x.inmate);
  const [errors, setErrors] = useState({});

  const {
    publicUserLastName,
    publicUserFirstName,

    facilityDropDown,
  } = useSelector((x) => x.master);

  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [allowDownload, setAllowDownload] = useState(false);
  const [disable, setDisable] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setAllowDownload(loadData);
    setPhotos({
      ...photos,
      InmateResidentID: "",
      ManagementUserID: user?.ManagementUserID,
      UserID: 0,
      UserFirstName: "",
      UserFirstNameId: 0,
      UserLastName: "",
      UserLastNameId: 0,
      PhotoAccess: 0,
      InmateFirstName: "",
      InmateLastName: "",
      Subject: "",
      NoticesFromDate: "",
      NoticesToDate: "",
      ActiveStatus: 4,
      ReceiverRead: 4,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    });
  }, [render]);

  useEffect(() => {
    if (photoList && photoList?.DataList?.length > 0 && allowDownload) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [photoList, allowDownload]);

  //Bind the Public UserNames for dropdown
  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    const facilityID =
      Inmate?.facilityID || inmate?.facilityID || commonFacilityCode;
    const inmateID = Inmate?.InmateID || inmate?.InmateID;

    // Dispatch actions for public last name and first name
    dispatch(
      masterActions.GetPublicLastName({
        facilityID,
        firstName: "", // As per the existing logic, leaving firstName as empty string
        inmatesId: inmateID,
      })
    );

    dispatch(
      masterActions.GetPublicFirstName({
        facilityID,
        lastName: "", // As per the existing logic, leaving lastName as empty string
        inmatesId: inmateID,
      })
    );

    // dispatch(
    //   inmateAction.LoadPhotoSearch({
    //     ...photos,
    //     FacilityID: facilityID,
    //     InmatesId: inmateID,
    //   })
    // );

    setPhotos({
      ...photos,
      FacilityID: facilityID,
      InmateID: inmateID,
      ManagementUserID: user?.ManagementUserID,
    });
  }, [Inmate || inmate]);

  const [photos, setPhotos] = useState({
    FacilityID: Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
    InmateID: 0,
    InmateResidentID: "",
    ManagementUserID: 0,
    UserID: 0,
    UserFirstName: "",
    UserFirstNameId: 0,
    UserLastName: "",
    UserLastNameId: 0,
    PhotoAccess: 0,
    InmateFirstName: "",
    InmateLastName: "",
    Subject: "",
    NoticesFromDate: getPastDate(6),
    NoticesToDate: getCurrentDate(),
    ActiveStatus: 4,
    ReceiverRead: 4,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  let updatedSearch = { ...photos };

  const handleSelectChange = (selectedOption, name) => {
    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserFirstNameId = selectedOption?.value || 0;
      updatedSearch.NoticesTitle = selectedOption?.label;
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserLastNameId = selectedOption?.value || 0;

      updatedSearch.MenuName = selectedOption?.label;

      updatedSearch.UserFirstName = "";
      updatedSearch.UserFirstNameId = 0;

      dispatch(
        masterActions.GetPublicFirstName({
          facilityID: updatedSearch.FacilityID,
          lastName: updatedSearch.UserLastName,
          inmatesId: updatedSearch.InmateID,
        })
      );
    };

    switch (name) {
      case "UserLastName":
        handleLastName();
        break;

      case "UserFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] = selectedOption?.value;
        // LoadPUGridList();
        break;
    }

    setPhotos(updatedSearch);
  };

  // const handleDateChange = (value, name) => {
  //   const date = fDate(value);
  //   updatedSearch[name] = date;

  //   setPhotos(updatedSearch);
  // };
  const handleDateChange = (value, name) => {
    const date = fDate(value);

    let updatedSearch = { ...photos };

    updatedSearch[name] = date;

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "NoticesFromDate" && photos.NoticesToDate) {
      const start = new Date(date);
      const end = new Date(photos.NoticesToDate);

      const sixMonthsLater = new Date(start);
      sixMonthsLater.setMonth(start.getMonth() + 6);

      if (end > sixMonthsLater) {
        updatedSearch.NoticesToDate = fDate(
          sixMonthsLater <= new Date()
            ? sixMonthsLater
            : new Date()
        );
      }
    }

    if (name === "NoticesToDate" && photos.NoticesFromDate) {
      const start = new Date(photos.NoticesFromDate);
      const end = new Date(date);

      const sixMonthsEarlier = new Date(end);
      sixMonthsEarlier.setMonth(end.getMonth() - 6);

      if (start < sixMonthsEarlier) {
        updatedSearch.NoticesFromDate = fDate(sixMonthsEarlier);
      }
    }
    setPhotos(updatedSearch);
  };


  const handleDateEnterKey = (event, name) => {
    handleDateInput({
      event,
      name,
      minDate: new Date(2017, 0, 1),
      maxDate: new Date(),
      onBlur: handleDateBlur,
    });
  };

  const handleDateBlur = (e, fieldName, manualValue) => {
    const value = manualValue || e.target.value;

    const updatedParam = handleDateRangeBlur({
      value,
      fieldName,
      startKey: "NoticesFromDate",
      endKey: "NoticesToDate",
      searchdata: photos,
      setErrorMessage: setErrors,
      monthrange: 6
    });

    setPhotos(updatedParam);
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {
      NoticesFromDate: "",
      NoticesToDate: "",
    };

    // ✅ DateRange filter validation
    if (!photos?.NoticesFromDate) {
      newErrors.NoticesFromDate = "Please Select From Date";
    }

    if (!photos?.NoticesToDate) {
      newErrors.NoticesToDate = "Please Select To Date";
    }


    setErrors(newErrors);

    // ✅ Stop submit if any validation exists
    if (
      newErrors.NoticesFromDate ||
      newErrors.NoticesToDate
    ) {
      return;
    }

    dispatch(
      inmateAction.LoadPhotoSearch({
        ...photos,
        RowCountPerPage: 1000,
      })

    );

    setAllowDownload(true);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearPhotoList());
  };

  const handleDownload = (e) => {
    e.preventDefault();
    const title = Inmate?.FirstName
      ? `Photos_${Inmate?.FirstName}_${Inmate?.LastName}`
      : inmate?.FirstName ? `Photos_${inmate?.FirstName}_${inmate?.LastName}` : (inmateInfoTabData?.length > 0 && `Photos_${inmateInfoTabData[0]?.LastName} ${inmateInfoTabData[0]?.FirstName}`);

    const photoDetails = photoList?.DataList?.map((obj) => ({
      Subject: obj?.PhotoSubject || "N/A",
      From: obj?.PhotoFrom || "N/A",
      PhotoCost: obj?.PhotoCost || "N/A",
      SendDate: obj?.PhotoSentDate || "N/A",
      Status: obj?.PhotoActionStatus || "N/A",
      FacilityName: obj?.FacilityCode || "N/A",
      base64: obj?.PhotoBinaryData || obj?.PhotoAttachPath || "N/A",
    }));

    const inmateName = Inmate?.InmateFullName
      ? Inmate?.InmateFullName
      : inmate?.InmateFullName ? inmate?.InmateFullName : (inmateInfoTabData?.length > 0 && `${inmateInfoTabData[0]?.LastName} ${inmateInfoTabData[0]?.FirstName}`);

    const inmateId = Inmate?.InmateResidentId
      ? Inmate?.InmateResidentId
      : inmate?.InmateResidentId ? inmate?.InmateResidentId : (inmateInfoTabData?.length > 0 && inmateInfoTabData[0]?.InmateResidentId);

    generatePhotoPDF(inmateName, inmateId, photoDetails, title);

    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearPhotoList());
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className="d-none" id="output"></div>
      <div className="p-2">
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-filter me-2"></i>Filter{" "}
        </h4>
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            {/* Frequency */}
            <div className="col-sm-12 col-md-6 mb-2">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate Last Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.LastName ||
                  inmate?.LastName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.LastName)}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-sm-12 col-md-6 mb-2">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.FirstName ||
                  inmate?.FirstName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)}
              </strong>
            </div>

            {/* Public User Last Name */}
            <div className="col-sm-6 col-md-6">
              <div className="form-floating mb-3">
                <SelectInput
                  options={publicUserLastName}
                  value={photos?.UserLastNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "UserLastName")
                  }
                  isMulti={false}
                  closeMenuOnSelect
                  isDisabled={disable}
                  isLoading={false}
                  isClearable={photos?.UserLastNameId !== 0}
                  placeholder="Select LastName"
                  label="Public User Last Name"
                />
              </div>
            </div>
            {/* Public User First Name */}
            <div className="col-sm-6 col-md-6">
              <div className="form-floating mb-3">
                <SelectInput
                  options={publicUserFirstName}
                  value={photos?.UserFirstNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "UserFirstName")
                  }
                  isMulti={false}
                  closeMenuOnSelect
                  isDisabled={disable}
                  isLoading={false}
                  isClearable={photos?.UserFirstNameId !== 0}
                  placeholder="Select First Name"
                  label="Public User First Name"
                />
              </div>
            </div>
            {/* From Date */}
            <div className="col-sm-6 col-md-6">
              <div className="form-floating mb-3">
                <DateInput
                  value={photos?.NoticesFromDate}
                  handleChange={(e) => handleDateChange(e, "NoticesFromDate")}
                  name="NoticesFromDate"
                  label="From Date"
                  required={true}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""}
                  isClearable={photos.NoticesFromDate}
                  preventClear={!photos.NoticesFromDate}
                  errorMessage={errors}
                  maxDate={
                    photos?.NoticesToDate
                      ? photos?.NoticesToDate
                      : new Date()
                  }
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "NoticesFromDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "NoticesFromDate")
                  }
                />
              </div>
            </div>
            {/* To Date */}
            <div className="col-sm-6 col-md-6">
              <div className="form-floating mb-3">
                <DateInput
                  value={photos?.NoticesToDate}
                  handleChange={(e) => handleDateChange(e, "NoticesToDate")}
                  name="NoticesToDate"
                  minDate={
                    photos?.NoticesFromDate
                      ? photos?.NoticesFromDate
                      : new Date(2017, 0, 1)
                  }
                  maxDate={
                    photos.NoticesFromDate
                      ? new Date(
                        Math.min(
                          new Date(photos.NoticesFromDate).setMonth(
                            new Date(photos.NoticesFromDate).getMonth() + 6
                          ),
                          new Date()
                        )
                      )
                      : new Date()
                  }
                  label="To Date"
                  required={true}
                  disabled={disable}
                  errorMessage={errors}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={photos.NoticesToDate}
                  preventClear={!photos.NoticesToDate}
                  handleBlur={(e) => handleDateBlur(e, "NoticesToDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "NoticesToDate")}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex flex-wrap gap-3">
            {(photoList?.DataList && photoList?.DataList?.length > 0 && allowDownload) ? (
              <div className="d-flex flex-wrap align-items-start">
                <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                  Data loaded successfully. Click download button to export
                  PDF.
                </label>
              </div>
            )
              :
              (photoList?.DataList && photoList?.DataList?.length === 0 && allowDownload) ? (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="fs-5 fw-bold text-danger">
                    No Data Available
                  </label>
                </div>
              ) :
                <p className="fst-italic font-bold">
                  Note : You can select a date range of up to six month only.
                </p>
            }

            <div className="d-flex flex-wrap ms-auto">
              {(photoList?.length === 0 ||
                photoList?.DataList?.length === 0) && (
                  <Button
                    className="me-2"
                    label="LOAD DATA"
                    type="submit"
                    imgsrc={loaddataimg}
                    status={"btn-label"}
                    disabled={false}
                  />
                )}

              {photoList?.DataList?.length > 0 && allowDownload && (
                <>
                  <Button
                    className="me-2"
                    label="CANCEL"
                    type="button"
                    variant="danger"
                    status="primary"
                    icon={"fa-solid fa-xmark"}
                    disabled={false}
                    onClick={handleCancel}
                  />
                  <Button
                    className="me-2"
                    label="Download"
                    icon={"fa-solid fa-download"}
                    type={"button"}
                    status={"success"}
                    disabled={false}
                    onClick={handleDownload}
                  />
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(Photos);
